const translations = {
    'scout.title': 'Send Scouts',
    'scout.missingSettlement': 'No settlement available to send scouts.',
    'scout.destination': 'Destination',
    'scout.tile': 'Tile: %s',
    'scout.distance': 'Distance: %d',
    'scout.units': 'Troops',
    'scout.unitsNone': 'No unit types available.',
    'scout.unitLine': '%s: %d/%d',
    'scout.unitPlus': '+1',
    'scout.unitMinus': '-1',
    'scout.food': 'Supplies',
    'scout.foodAvailable': 'Food available: %d',
    'scout.foodSelected': 'Food selected: %d',
    'scout.foodSuggested': 'Suggested: %d',
    'scout.foodPlus': '+ food',
    'scout.foodMinus': '- food',
    'scout.launch': 'Launch',
    'scout.send': 'Send scouts',
    'scout.missionTitle': 'Scouting Mission',
    'scout.missionMissing': 'Scouting mission not found.',
    'scout.missionStatus': 'Status',
    'scout.missionTarget': 'Target: %s',
    'scout.missionState.traveling': 'Traveling',
    'scout.missionState.battle': 'In battle',
    'scout.missionState.holding': 'Holding position',
    'scout.missionState.returning': 'Returning',
    'scout.missionState.complete': 'Complete',
    'scout.missionProgress': 'Progress: %d/%d',
    'scout.missionBattleProgress': 'Battle: %d/%d',
    'scout.missionPlan': 'Plan',
    'scout.missionPlanEmpty': 'No planned target.',
    'scout.missionPlanNext': 'Next target: %s',
    'scout.missionPlanAlter': 'Alter next target',
    'scout.missionPlanClear': 'Clear plan',
    'scout.missionPlanHint': 'Select a tile to set the next target.',
    'scout.missionOrders': 'Orders',
    'scout.missionReturn': 'Return to settlement',
    'scout.missionReport': 'Battle report',
    'scout.missionReportOpen': 'Open report',
};

export default translations;
